// extracted by mini-css-extract-plugin
module.exports = {"card":"_3hmzA9LV8eXwvQ-c2sPly9","active":"_3eqO0Ev50Tr0HXRP_w_p0d","flex":"uE4EFJh9BSC-P4mLFTJ7x","cardOuter":"GZJifeL9k_tLKRLEiI2yJ","image":"w3uGAkwzvUK5RSx8zfQJJ"};